import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box } from "@mui/material";
import { NETWORK_ICON_MAP } from "../utils/constants";
export const McIcon = React.memo(({ mc, rounded = false }) => {
    if (!mc)
        return (_jsx(Box, { className: "all-Font-Sizes", sx: { width: 28, height: 28, borderRadius: "50%", backgroundColor: "#f4f4f5", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, color: "#71717a" }, children: "NA" }));
    const entry = NETWORK_ICON_MAP[mc.toLowerCase()] || NETWORK_ICON_MAP[mc];
    return entry
        ? _jsx("img", { src: entry.icon, alt: entry.name, title: entry.name, style: { width: 28, height: 28, objectFit: "contain", borderRadius: rounded ? "50%" : "0" } })
        : _jsx(Box, { className: "all-Font-Sizes", sx: { width: 28, height: 28, borderRadius: "50%", backgroundColor: "#f4f4f5", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, color: "#71717a" }, children: mc.charAt(0).toUpperCase() });
});
